import { createFileRoute } from '@tanstack/react-router';
import { Scale } from 'lucide-react';
import { ComingSoon } from '@/components/layout/ComingSoon';

export const Route = createFileRoute('/_app/lancamentos/ajustes')({
  component: AjustesPage,
});

function AjustesPage() {
  return (
    <ComingSoon
      eyebrow="Lançamento · Mensal"
      title="Ajustes"
      description="Ajustes contábeis e reclassificações do convênio."
      icon={Scale}
      bullets={[
        'Reclassificação de despesas',
        'Correções de competência',
        'Trilha de auditoria com motivo',
      ]}
      etaLabel="próxima fase"
    />
  );
}
